import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './lib/store';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Players from './pages/Players';
import PlayerDetail from './pages/PlayerDetail';
import Bets from './pages/Bets';
import Games from './pages/Games';
import DemoPlay from './pages/DemoPlay';
import ApiKeys from './pages/ApiKeys';
import Reports from './pages/Reports';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
	const { isAuthenticated } = useAuthStore();

	if (!isAuthenticated) {
		return <Navigate to="/login" replace />;
	}

	return <>{children}</>;
}

export default function App() {
	return (
		<Routes>
			<Route path="/login" element={<Login />} />
			<Route
				path="/*"
				element={
					<ProtectedRoute>
						<Layout>
							<Routes>
								<Route path="/" element={<Dashboard />} />
								<Route path="/players" element={<Players />} />
								<Route path="/players/:id" element={<PlayerDetail />} />
								<Route path="/bets" element={<Bets />} />
								<Route path="/games" element={<Games />} />
								<Route path="/demo" element={<DemoPlay />} />
								<Route path="/api-keys" element={<ApiKeys />} />
								<Route path="/reports" element={<Reports />} />
							</Routes>
						</Layout>
					</ProtectedRoute>
				}
			/>
		</Routes>
	);
}
